import ReviewFormContainer from './review_form_container';

const ReviewForm = ReviewFormContainer;
export default ReviewForm;
